import React from 'react';

export const PagoCancelado = (data) => {
    const {topup_amount,mdn} = data;
    return (
      <div className='contenedorTicket'>
          <div className='parte1'>
              <div className='iconoError'></div>
              <div className='tituloTicket'>Operación cancelada</div>
              
              <div className='cantidadPagada'>${topup_amount}.00</div>
              <p>Cancelaste tu recarga, abre el enlace del mensaje para intentar de nuevo</p>
          </div>
          <div className='parte2'>
              <div className='contNum'>
                  <span className='icoCel'></span>
                  <span className='textoIco'>{mdn}</span>
              </div>
          </div>
      </div>
    )
}
